import { makeStyles, tokens, shorthands } from "@fluentui/react-components";

const style = makeStyles({
  clientContent: {
    ...shorthands.margin("30px", "auto", "30px", "auto"),
    ...shorthands.padding("20px"),
    ...shorthands.border("1px", "solid", "#E2E8F0"),
    display: "inline-flex",
    borderRadiusMedium: tokens.borderRadiusMedium,
    justifyContent: "space-between",
  },
  client_field: {
    ...shorthands.margin(0, 0, "15px", 0),
    "@media (min-width: 1024px)": {
      width: "calc(50% - 15px)",
    },

    "@media (max-width: 1024px)": {
      width: "100%",
    },
  },
  customBtn: {
    ...shorthands.margin(0, "10px", 0, "10px"),
    "@media (min-width: 1024px)": {
      minWidth: "150px",
    },
  },
  formfooter: {
    ...shorthands.margin("10px", "auto", 0, "auto"),
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "center",
  },
});

export default style;
